import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.clas)
      ? (_openBlock(), _createBlock(_component_v_app_bar, {
          key: 0,
          color: "primary",
          dark: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              style: {"position":"absolute"},
              icon: "",
              onClick: _ctx.routerBack
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_toolbar_title, { style: {"min-width":"fit-content"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.clas.className) + " 日誌", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
      }, [
        _createVNode(_component_DatePager, {
          date: _ctx.date,
          onAddDay: _ctx.addDay,
          onSubtractDay: _ctx.subtractDay
        }, null, 8, ["date", "onAddDay", "onSubtractDay"])
      ]),
      _createVNode(_component_v_divider)
    ]),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, "ねらい", -1)),
          _createVNode(_component_v_textarea, {
            class: "pt-0",
            "auto-grow": "",
            rows: "3",
            solo: "",
            flat: "",
            "background-color": "grey lighten-2",
            modelValue: _ctx.aim,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.aim) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, "活動内容　午前", -1)),
          _createVNode(_component_v_textarea, {
            class: "pt-0",
            "auto-grow": "",
            rows: "3",
            solo: "",
            flat: "",
            "background-color": "grey lighten-2",
            modelValue: _ctx.activityAm,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activityAm) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, "活動内容　午後", -1)),
          _createVNode(_component_v_textarea, {
            class: "pt-0",
            "auto-grow": "",
            rows: "3",
            solo: "",
            flat: "",
            "background-color": "grey lighten-2",
            modelValue: _ctx.activityPm,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activityPm) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, "評価と反省", -1)),
          _createVNode(_component_v_textarea, {
            class: "pt-0",
            "auto-grow": "",
            rows: "3",
            solo: "",
            flat: "",
            "background-color": "grey lighten-2",
            modelValue: _ctx.assessment,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.assessment) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, "保護者支援", -1)),
          _createVNode(_component_v_textarea, {
            class: "pt-0",
            "auto-grow": "",
            rows: "3",
            solo: "",
            flat: "",
            "background-color": "grey lighten-2",
            modelValue: _ctx.support,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.support) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, "申請者", -1)),
          _createVNode(_component_v_select, {
            items: _ctx.allStaff,
            "item-title": "fullName",
            "item-value": "userId",
            modelValue: _ctx.appliedBy,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.appliedBy) = $event)),
            variant: "outlined"
          }, null, 8, ["items", "modelValue"])
        ]),
        _createVNode(_component_v_row, {
          class: "flex-column mt-3 mb-5",
          "align-content": "center",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "",
                  color: "#6C6C6C",
                  dark: "",
                  depressed: "",
                  width: "100%",
                  onClick: _ctx.saveDraft,
                  loading: _ctx.btnDraftLoading,
                  disabled: !_ctx.checkStatus
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "申請解除")
                    ], -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "",
                  color: "primary",
                  depressed: "",
                  width: "100%",
                  onClick: _ctx.saveApply,
                  loading: _ctx.btnApplyLoading,
                  disabled: _ctx.checkStatus
                }, {
                  default: _withCtx(() => [
                    (_ctx.checkStatus)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "申請済", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "申請", -1)
                        ]))]))
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout,
      outlined: "",
      top: "",
      color: "primary"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "outline-primary",
          variant: "text",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.snackbar = false))
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
            _createTextVNode(" × ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dateDialogFlg,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_date_picker, {
          modelValue: _ctx.selectedDate,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedDate) = $event)),
            _ctx.dateSelected
          ],
          type: "date",
          "day-format": (date) => new Date(date).getDate(),
          "no-title": "",
          "hide-header": "",
          color: "primary",
          style: {"transform":"scale(0.8)"}
        }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}